// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect, useRef } from 'react';
import TasklistFilter from './TasklistFilter';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { useTranslation } from "react-i18next";
import { gridSpacing } from 'app/constant';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const TransactionHistoryModal = ({
    transactionHistoryModalOpen,
    setTransactionHistoryModalOpen,
    customerRow,
    handleRefresh
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);
    const buttonRef = useRef(null);

    const [customerID, setCustomerID] = useState(0);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const [filterCreatedDateFrom, setFilterCreatedDateFrom] = useState(dayjs().subtract(3, 'days'));
    const [filterCreatedDateTo, setFilterCreatedDateTo] = useState(dayjs());
    const [filterTransactionHistoryTypeID, setFilterTransactionHistoryTypeID] = useState('');

    const { data: transactionHistoryTypes } = useFetchData('/TransactionHistoryTypes/All');

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const nameToTranslationKey = {
        'Deposit': 'deposit',
        'Withdrawal': 'withdrawal',
        'Adjustment': 'adjustment',
        'Registration Bonus': 'registrationBonus',
        'Negative Adjustment': 'negativeAdjustment',
        'Launch Task': 'launchTask',
        'Refund Task With Profit': 'refundTask',
        'Assessment Bonus': 'assessmentBonus',
        'Check In Bonus': 'checkInBonus',
        'Withdrawal Rejection': 'withdrawalRejection',
        'Task Profit': 'taskProfit',
    };

    const handleOpenModal = () => {
        setTransactionHistoryModalOpen(true);
        setCustomerID(customerRow.id);
    };

    useEffect(() => {
        console.log('customerRow', customerRow);
        if (transactionHistoryModalOpen && customerRow?.id) {
            setCustomerID(customerRow.id);
            fetchTransactionHistory(customerRow.id);
        }
    }, [transactionHistoryModalOpen, customerRow]);

    const [transactionHistory, setTransactionHistory] = useState([]);
    const fetchTransactionHistory = async (passedCustomerID) => {
        try {
            let apiCustomerID = !passedCustomerID ? customerID : passedCustomerID;

            let url = `/Backend/CustomerTransactionHistory?customerID=${apiCustomerID}&createdDateFrom=${filterCreatedDateFrom.format('YYYY-MM-DD')}&createdDateTo=${filterCreatedDateTo.format('YYYY-MM-DD')}`;
                
            if (filterTransactionHistoryTypeID !== '') {
                url += `&transactionTypeID=${parseFloat(filterTransactionHistoryTypeID)}`;
            }
            
            const res = await axiosInstance.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setTransactionHistory(res.data);
            }
        } catch (error) {

        }
    };

    return (
        <>
            <Modal
                open={transactionHistoryModalOpen}
                onClose={() => setTransactionHistoryModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("customer.transactionHistory")}
                        </Typography>
                        <Cancel onClick={() => setTransactionHistoryModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Box
                        id="modal-modal-description"
                        sx={{
                            overflowY: 'auto',
                            marginTop: '20px'
                        }}
                    >
                        <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                            <Grid item container xs={12} md={6} lg={6}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <span style={{ color: 'red' }}>*</span>{t("customer.createdDate")} :
                                    </Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} style={{fontSize: '14px'}}>
                                        <DatePicker
                                            value={filterCreatedDateFrom}
                                            slotProps={{
                                                textField: {
                                                    error: false,
                                                    size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                                    sx: {
                                                        '& .MuiInputBase-root': {
                                                        fontSize: '13px',      // font size of the input
                                                        padding: '4px 8px',    // optional: reduce input padding
                                                        minHeight: '36px',     // optional: control input height
                                                        },
                                                        '& .MuiInputBase-input': {
                                                        fontSize: '13px',      // font size inside input
                                                        padding: '8.5px 14px', // adjust input padding if needed
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                        fontSize: '13px',      // label font size
                                                        },
                                                    },
                                                }
                                            }}
                                            onChange={(newValue) => setFilterCreatedDateFrom(newValue)}
                                        />
                                    </LocalizationProvider>
                                    -
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            value={filterCreatedDateTo}
                                            slotProps={{
                                                textField: {
                                                    error: false,
                                                    size: 'small', // makes the input smaller (MUI supports 'small' and 'medium')
                                                    sx: {
                                                        '& .MuiInputBase-root': {
                                                        fontSize: '13px',      // font size of the input
                                                        padding: '4px 8px',    // optional: reduce input padding
                                                        minHeight: '36px',     // optional: control input height
                                                        },
                                                        '& .MuiInputBase-input': {
                                                        fontSize: '13px',      // font size inside input
                                                        padding: '8.5px 14px', // adjust input padding if needed
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                        fontSize: '13px',      // label font size
                                                        },
                                                    },
                                                }
                                            }}
                                            onChange={(newValue) => setFilterCreatedDateTo(newValue)}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid item container xs={12} md={6} lg={3}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '14px',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {t("customer.transactionHistoryType")} :
                                    </Typography>
                                    <FormControl fullWidth>
                                        <Select
                                            displayEmpty
                                            value={filterTransactionHistoryTypeID}
                                            onChange={(e) => setFilterTransactionHistoryTypeID(e.target.value)}
                                            sx={{
                                                fontSize: '13px',
                                                minHeight: '36px',
                                                '& .MuiSelect-select': {
                                                    fontSize: '13px',
                                                    padding: '10px 14px',
                                                },
                                                '& .MuiInputBase-root': {
                                                    fontSize: '13px',
                                                    minHeight: '36px',
                                                    padding: '10px 14px',
                                                },
                                            }}
                                        >
                                            <MenuItem value=''>{t("customer.pleaseSelectTransactionHistoryType")}</MenuItem>
                                            {transactionHistoryTypes.map((item, index) => (
                                                <MenuItem value={item.id} key={index}>
                                                    {nameToTranslationKey[item.name] ? t(`customer.${nameToTranslationKey[item.name]}`) : item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item container xs={12} md={6} lg={3}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            display: 'block',
                                            mx: 'auto',
                                            width: '150px',
                                            backgroundColor: deepPurple[500],
                                            marginTop: '20px',
                                            marginBottom: '20px'
                                        }}
                                        onClick={() => fetchTransactionHistory()}
                                        disabled={filterBtnDisabled}
                                    >
                                        {t("customer.filter")}
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <TableContainer sx={{ maxHeight: '70vh' }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell key='details' style={{ minWidth: 80 }}>{t("customer.details")}</TableCell>
                                        <TableCell key='balance' style={{ minWidth: 80 }}>{t("customer.price")}</TableCell>
                                        <TableCell key='walletBalance' style={{ minWidth: 120 }}>{t("customer.walletBalance")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {transactionHistory.map((row) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                <TableCell key={`details-${row.id}`} style={{fontSize: "12px"}}>
                                                    <span style={{fontSize: '14px', fontWeight: 'bolder'}}>
                                                        {/* {row.transactionTypeName} */}
                                                        {nameToTranslationKey[row.transactionTypeName] ? t(`customer.${nameToTranslationKey[row.transactionTypeName]}`) : row.transactionTypeName}
                                                    </span><br/>
                                                    {
                                                        row.createdDate && 
                                                        <>
                                                            {t("customer.createdAt")} 
                                                            {row.createdDate.split('T')[0]} {new Date(
                                                                '1970-01-01T' + row.createdDate.split('T')[1] + 'Z'
                                                            ).toLocaleTimeString('en-US', {
                                                                timeZone: 'UTC',
                                                                hour12: true,
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric'
                                                            })}
                                                        </>
                                                    } <br/>
                                                </TableCell>
                                                <TableCell key={`balance-${row.id}`} style={{fontSize: "12px"}}>
                                                    {t("customer.amount")} : {row.amount} <br/>
                                                </TableCell>
                                                <TableCell key={`walletBalance-${row.id}`} style={{fontSize: "12px"}}>
                                                    <span style={{border: '2px solid red', padding: '5px', display: 'inline-block', color: 'red', borderRadius: '5px'}}>{row.beforeBalance}</span> {' > '} 
                                                    <span style={{border: '2px solid darkgreen', padding: '5px', display: 'inline-block', color: 'darkgreen', borderRadius: '5px'}}>{row.afterBalance}</span>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default TransactionHistoryModal;